import { render } from "./postalcodes.vue?vue&type=template&id=634c3bae&lang=html"
import script from "./postalcodes.vue?vue&type=script&lang=js"
export * from "./postalcodes.vue?vue&type=script&lang=js"

import "./postalcodes.vue?vue&type=style&index=0&id=634c3bae&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__